/* eslint-disable no-console */
import {ApolloClient} from 'apollo-client'
import {InMemoryCache, IntrospectionFragmentMatcher, defaultDataIdFromObject} from 'apollo-cache-inmemory'
import {HttpLink} from 'apollo-link-http'
import {onError} from 'apollo-link-error'
import {ApolloLink} from 'apollo-link'
import introspectionQueryResultData from './fragmentTypes.json'
import {config} from '../config'
import {createVnAuthLink} from '../vn-access/auth-link'
import {readApiDomain, resolveEndpoints, bounceToPwa} from '../vn-access/runtime-api'
import {classifyNetworkFailure, recoverFromVnFailure} from '../vn-access/recovery'

// Resolve the GraphQL endpoint: VN mode reads today's rotating host from the shared localStorage
// (falling back to a bounce if it is missing); every other brand keeps the baked cookie endpoint.
const resolveGraphqlEndpoint = () => {
  if (!config.vnAccess) return config.graphqlEndpoint
  const domain = readApiDomain()
  if (!domain) {
    bounceToPwa()
    return config.graphqlEndpoint
  }
  return resolveEndpoints(domain).graphqlEndpoint
}

export const getApolloClient = () => {
  const cache = new InMemoryCache({
    fragmentMatcher: new IntrospectionFragmentMatcher({introspectionQueryResultData}),
    dataIdFromObject: object => defaultDataIdFromObject(object)
  })

  const errorLink = onError(({graphQLErrors, networkError}) => {
    if (graphQLErrors) {
      graphQLErrors.map(({message, locations, path}) =>
        console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`))
    }
    if (networkError) {
      console.log(`[Network error]: ${networkError}`)
      // VN: apply the shared recovery policy. A 401 (revoked bearer) clears + bounces; a
      // response-less transport failure (rotated-away host) bounces; any other HTTP status is a
      // reachable host returning an error — surface it, never bounce (avoids an /app⇄/ loop).
      if (config.vnAccess) {
        const statusCode = networkError && 'statusCode' in networkError ? networkError.statusCode : undefined
        recoverFromVnFailure(classifyNetworkFailure(statusCode))
      }
    }
  })

  const httpLink = new HttpLink({
    uri: resolveGraphqlEndpoint(),
    credentials: config.vnAccess ? 'omit' : 'include'
  })

  const links = config.vnAccess
    ? [errorLink, createVnAuthLink(), httpLink]
    : [errorLink, httpLink]

  return new ApolloClient({link: ApolloLink.from(links), cache})
}
